
function ErrorAstrick() {
  return <span className="text-error"> * </span>;
}

export default ErrorAstrick;
